// BeneficiaryList.js
import React from 'react';
import { Row } from 'react-bootstrap';
import { Text } from '../../Atoms';
import PageTitle from '../../Components/Dashboard/PageTitle';
import BeneficiaryCard from './BeneficiaryCard';
import propTypes from 'prop-types';

const BeneficiaryListToDelete = ({ beneficiaries, onSelectBeneficiary }) => {
  return (

      <div className="template-scroll profile-container">
        <PageTitle titleText="Profil" canGoBack={false} />
        <div className="profile-title">
          <Text
            text={
              window.innerWidth <= 768
                ? 'Séléctionnez un bénéficiaire que vous souhaitez supprimer'
                : 'Séléctionnez un bénéficiaire que vous souhaitez supprimer de votre contrat :'
            }
            type="h6"
            className="text-default-size text-default-font"
          />
        </div>
        <div className="profile-card-container">
          <Row>
            {beneficiaries.map((beneficiary, index) => (
              <BeneficiaryCard
                key={beneficiary.value || index}
                beneficiary={beneficiary}
                index={index}
                totalBeneficiaries={beneficiaries.length}
                onSelect={onSelectBeneficiary}
              />
            ))}
          </Row>
        </div>
      </div>

  );
};

BeneficiaryListToDelete.propTypes = {
  beneficiaries: propTypes.arrayOf(
    propTypes.shape({
      value: propTypes.string,
    })
  ).isRequired,
  onSelectBeneficiary: propTypes.func.isRequired,
};

export default BeneficiaryListToDelete;
